export default __webpack_public_path__ + "static/media/step5.c10ce317.png";